import { Container, Link, Text } from '@loomhq/lens';
import React from 'react';
import { useSelector } from 'react-redux';

import { CONTENT_LIMIT_BANNER_CLICKED } from 'constants/events';
import { CONTENT_LIMIT_BANNER } from 'constants/scopes';
import { track } from 'utilities/analytics';

import { useWorkspaceCounts } from 'hooks/useCounts';
import { useWorkspaceLimit } from 'hooks/useWorkspaceLimit';
import { useGetSelectedWorkspace } from 'hooks/workspace';

import { PLANS_AND_BILLING } from '../../constants/routes';

import Scopes from 'components/scopes';

import './styles.less';

const WorkspaceContentLimitBanner = () => {
  const selectedWorkspace = useGetSelectedWorkspace();
  const limits = useWorkspaceLimit();
  const counts = useWorkspaceCounts();

  let showBanner = false;

  const hasRecorded = useSelector(
    state => state.checklist.first_video_recording
  );

  if (hasRecorded && counts && limits) {
    const totalAssets =
      (counts.videos?.total_workspace_videos || 0) +
      (counts.screenshots?.total_workspace_screenshots || 0);

    showBanner = totalAssets >= limits?.TOTAL_ASSETS;
  }

  return showBanner ? (
    <Scopes names={CONTENT_LIMIT_BANNER}>
      <div className="banner">
        <Container
          width="100%"
          backgroundColor="offWhite"
          padding="medium"
          radius="medium"
        >
          <Text alignment="center">
            <Text fontWeight="bold" isInline>
              You’ve reached your limit of {limits?.TOTAL_ASSETS} free videos
              and screenshots.{' '}
            </Text>
            <Text isInline>
              <Link
                href={PLANS_AND_BILLING}
                className="linkWithoutUnderline"
                onClick={() =>
                  track(
                    CONTENT_LIMIT_BANNER_CLICKED,
                    {
                      userId: window.loomSSRUser.id,
                      workspaceId: selectedWorkspace.id,
                      totalVideos: counts?.videos?.total_workspace_videos || 0,
                      totalScreenshots:
                        counts?.screenshots?.total_workspace_screenshots || 0,
                    },
                    () => (window.location.href = PLANS_AND_BILLING)
                  )
                }
              >
                Upgrade your plan
              </Link>{' '}
              for unlimited content with no restriction on recording time.
            </Text>
          </Text>
        </Container>
      </div>
    </Scopes>
  ) : (
    <div />
  );
};

export default WorkspaceContentLimitBanner;
